
export function objectToFormData (data, keys) {
  const formData = new FormData()
  keys.forEach((key) => {
    if (data[key]) {
      formData.append(key, data[key])
    }
  })
  return formData
}

export function convertFileToBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export function validateExtension (fileName, validExtensions = ['png', 'jpg', 'jpeg', 'svg', 'pdf', 'doc', 'docx', 'eps', 'ai']) {
  const filePart = fileName.split('.')
  const fileTypeExtension = filePart[filePart.length - 1].toLowerCase()
  return validExtensions.includes(fileTypeExtension)
}
